<script setup>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import { computed } from 'vue'

const props = defineProps({
  visible: Boolean,
  mode: {
    type: String,
    default: 'archive', // 'archive' | 'unarchive'
    validator: (value) => ['archive', 'unarchive'].includes(value)
  },
  customerName: {
    type: String,
    default: '',
  },
  workName: {
    type: String,
    default: '',
  },
  employeeName: {
    type: String,
    default: '',
  },
  contactName: {
    type: String,
    default: '',
  },
  facilityName: {
    type: String,
    default: '',
  },
  documentName: {
    type: String,
    default: '',
  },
  contractName: {
    type: String,
    default: '',
  }

})
const emit = defineEmits(['update:visible', 'confirm'])

const isUnarchive = computed(() => props.mode === 'unarchive')

function onUpdateVisible(value) {
  emit('update:visible', value)
}

function close() {
  emit('update:visible', false)
}
function confirm() {
  emit('confirm')
  close()
}
</script>


<template>
  <Dialog
      :visible="visible"
      @update:visible="(v) => $emit('update:visible', v)"
      header="Подтвердите"
      :closable="false"
      modal
  >
    <div class="mb-4 text-center text-md">
      <template v-if="isUnarchive">
        <span v-if="customerName">Вернуть из архива <b>«{{ customerName }}»</b>?</span>
        <span v-else-if="workName">Вернуть из архива <b>«{{ workName }}»</b>?</span>
        <span v-else-if="employeeName">Вернуть из архива <b>«{{ employeeName }}»</b>?</span>
        <span v-else-if="contactName">Вернуть из архива <b>«{{ contactName }}»</b>?</span>
        <span v-else-if="facilityName">Вернуть из архива <b>«{{ facilityName }}»</b>?</span>
        <span v-else-if="documentName">Вернуть из архива документ <b>«{{ documentName }}»</b>?</span>
        <span v-else-if="contractName">Вернуть из архива договор <b>«{{ contractName }}»</b>?</span>
        <span v-else>Восстановить это?</span>
      </template>
      <template v-else>
        <span v-if="customerName">Поместить в архив <b>«{{ customerName }}»</b>?</span>
        <span v-else-if="workName">Поместить в архив <b>«{{ workName }}»</b>?</span>
        <span v-else-if="employeeName">Поместить в архив <b>«{{ employeeName }}»</b>?</span>
        <span v-else-if="contactName">Поместить в архив <b>«{{ contactName }}»</b>?</span>
        <span v-else-if="facilityName">Поместить в архив <b>«{{ facilityName }}»</b>?</span>
        <span v-else-if="documentName">Поместить в архив документ <b>«{{ documentName }}»</b>?</span>
        <span v-else-if="contractName">Поместить в архив договор <b>«{{ contractName }}»</b>?</span>
        <span v-else>Архивировать это?</span>
      </template>
    </div>
    <template class="flex justify-center gap-2">
      <Button
        :label="isUnarchive ? 'Восстановить' : 'В архив'"
        :severity="isUnarchive ? 'success' : 'danger'"
        @click="confirm"
        rounded
        size="small"
      />
      <Button label="Отмена" @click="$emit('update:visible', false)" severity="secondary" rounded size="small"/>
    </template>
  </Dialog>

</template>


<style scoped>

</style>